/**
 * Shared constants and runtime detection used by both browser and server loggers.
 * This module avoids being bundled into the browser by being a pure Node.js import
 * (no browser-only APIs used), and is only used at initialization time.
 */

const isDeployed =
  !!process.env.NEXT_PUBLIC_VERCEL_ENV ||
  !!process.env.RAILWAY_ENVIRONMENT_NAME ||
  !!process.env.NF_OBJECT_ID

const isEdge = process.env.NEXT_RUNTIME === 'edge'
const isBrowser =
  isEdge || (typeof globalThis !== 'undefined' && 'window' in globalThis)
const isDev = process.env.NODE_ENV === 'development' && !isDeployed
const isTest = process.env.NODE_ENV === 'test' || process.env.TEST === 'true'

const LOG_LEVEL =
  process.env.LOG_LEVEL ||
  process.env.NEXT_PUBLIC_LOG_LEVEL ||
  (isDev ? 'debug' : 'info')

const DD_LOG_LEVEL = process.env.DD_LOG_LEVEL || LOG_LEVEL
const DD_SERVICE =
  process.env.DD_SERVICE ||
  process.env.NEXT_PUBLIC_DD_SERVICE ||
  (process.env.npm_package_name || process.env.PWD?.split('/').at(-1)) +
    '-dupe-com'

let DD_ENV =
  process.env.DD_ENV ||
  process.env.ENV ||
  process.env.NEXT_PUBLIC_DD_ENV ||
  process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV ||
  process.env.NEXT_PUBLIC_ENV ||
  process.env.RAILWAY_ENVIRONMENT_NAME ||
  process.env.NF_ENV ||
  'dev'

// In a deployed preview environment, set the env for consistency with api and other services
if (
  process.env.GIT_PULL_REQUEST_ID ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID
) {
  DD_ENV = `dupe-com-pr-${process.env.GIT_PULL_REQUEST_ID || process.env.NEXT_PUBLIC_VERCEL_GIT_PULL_REQUEST_ID}`
}

const DD_VERSION =
  process.env.DD_VERSION ||
  process.env.VERSION ||
  process.env.GIT_COMMIT_SHA ||
  process.env.NEXT_PUBLIC_DD_VERSION ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
  process.env.NEXT_PUBLIC_VERSION ||
  'dev'

// RUM sampling disabled to reduce costs - can be re-enabled via env var if needed
const DD_RUM_SESSION_SAMPLE_RATE = parseInt(
  process.env.DD_RUM_SESSION_SAMPLE_RATE ||
    process.env.NEXT_PUBLIC_DD_RUM_SESSION_SAMPLE_RATE ||
    '0',
  10
)

// Trace sampling disabled to reduce costs - can be re-enabled via env var if needed
const DD_TRACE_SAMPLE_RATE = parseInt(
  process.env.DD_TRACE_SAMPLE_RATE ||
    process.env.NEXT_PUBLIC_DD_TRACE_SAMPLE_RATE ||
    '0',
  10
)

export {
  isDeployed,
  isEdge,
  isBrowser,
  isDev,
  isTest,
  LOG_LEVEL,
  DD_LOG_LEVEL,
  DD_SERVICE,
  DD_ENV,
  DD_VERSION,
  DD_RUM_SESSION_SAMPLE_RATE,
  DD_TRACE_SAMPLE_RATE,
}
